


































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import DateRanges from "@/data/dateranges";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import { IAccount } from "@/models/accounts";
import { AdminRoutes } from "@/data/enums/router";

@Component({
  components: {
    "chart-provider": () =>
      import("@/components/app/global/stats/charts/chart/chartProvider.vue"),
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "amount-total-collected": () =>
      import("@/components/app/global/stats/amountTotalCollected.vue"),
    "invoices-total": () =>
      import("@/components/app/global/stats/invoicesTotal.vue"),
    "amount-total-invoiced": () =>
      import("@/components/app/global/stats/amountTotalInvoiced.vue"),
    "total-unpaid-invoices": () =>
      import("@/components/app/global/stats/invoicesTotalUnpaid.vue"),
    "amount-total-outstanding": () =>
      import("@/components/app/global/stats/amountTotalOutstanding.vue"),
    "orders-total": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "tickets-total": () =>
      import("@/components/app/global/stats/ticketsTotal.vue"),
    "tickets-open": () =>
      import("@/components/app/global/stats/ticketsOpen.vue"),
    "chart-revenue": () =>
      import("@/components/app/global/stats/charts/revenueChart.vue"),
    "chart-invoices": () =>
      import("@/components/app/global/stats/charts/invoicesChart.vue")
  }
})
export default class AdminClientStats extends Mixins(StatsStorageMixin) {
  // Props
  @Prop({ required: true })
  public client!: IClient;
  // Data
  public currencyCode = null;
  public range = this.tryGetStatDateFromStorage(DateRanges.ranges.last30days);

  public adminRoutes = AdminRoutes;
  // Computed
  public get accountId(): IAccount["id"] {
    return this.$_.get(this.client, "accounts[0].id");
  }
}
